import React, { useState } from 'react';
import { Box, IconButton, Collapse, Typography as MuiTypography } from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import classnames from 'classnames';

// styles
import useStyles from './styles';

// components
import Markdown from '../Markdown';

const NewsBanner = ({ newsItems = [] }) => {
    const classes = useStyles();
    const [expandedItems, setExpandedItems] = useState({});

    const handleExpandClick = (index) => {
        setExpandedItems((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    return (
        <>
            {newsItems.map((newsItem, index) => {
                const expanded = expandedItems[index] || false;

                return (
                    <Box key={index} className={classes.newsBanner}>
                        <div className={classes.newsHeader}>
                            <div style={{ flex: 1, paddingRight: 16 }}>
                                <MuiTypography className={classes.newsTitle} component="h2">
                                    {newsItem.title}
                                </MuiTypography>
                                <MuiTypography className={classes.newsDescription}>
                                    {newsItem.description}
                                </MuiTypography>
                            </div>

                            <IconButton
                                className={classes.expandButton}
                                onClick={() => handleExpandClick(index)}
                                aria-expanded={expanded}
                                aria-label="show more"
                            >
                                <ExpandMoreIcon
                                    className={classnames(classes.expandIcon, {
                                        [classes.expandIconRotated]: expanded,
                                    })}
                                />
                            </IconButton>
                        </div>

                        <Collapse in={expanded} timeout={400}>
                            <div className={classes.expandedContent}>
                                <div className={classes.expandedContentInner}>
                                    {newsItem.image && (
                                        <img
                                            src={newsItem.image}
                                            alt={newsItem.imageAlt || ''}
                                            className={classes.newsImage}
                                        />
                                    )}

                                    <div className={classes.newsContent}>
                                        <Markdown>{newsItem.content}</Markdown>
                                    </div>
                                </div>
                            </div>
                        </Collapse>
                    </Box>
                );
            })}
        </>
    );
};

export default NewsBanner;
